import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import { Button, CircularProgress } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import Modal, { CommonModalProps } from "..";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { GetObject } from "../../../Redux/Reducers/redux-slice-asset";
import { useAppSelector } from "../../../Redux/redux-store";
import MoveAssetTreeView from "../../TreeView/MoveAssetTreeView/move-asset-tree-view";
import { GetSelectedItems, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";

export type ModalSelectGroupParentElementProps = {
  selectableObjectLayers?: ObjectLayer[];
  objectsIdsToDisable: number[];
  onCreateGroupHereClick: (selectedAssetId: number, closeModal: () => void, disableLoader: () => void) => void;
};

export type ModalSelectGroupParentProps = CommonModalProps<ModalSelectGroupParentElementProps>;

const ModalSelectGroupParent = React.forwardRef<any, ModalSelectGroupParentProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, ...elementProps } = props;
  const { selectableObjectLayers, objectsIdsToDisable, onCreateGroupHereClick } = elementProps;

  const currentObject = useAppSelector(GetObject);
  const selectedItems = useAppSelector(GetSelectedItems(TreeContext.MoveDistrib));
  const [titleId, setTitleId] = React.useState<number | null>();
  const [showLoader, setShowLoader] = React.useState(false);

  const handleMoveAsset = React.useCallback(() => {
    if (selectedItems) {
      setShowLoader(true);
      onCreateGroupHereClick(selectedItems[0], closeModal, () => setShowLoader(false));
    }
  }, [selectedItems, onCreateGroupHereClick]);

  React.useEffect(() => {
    if (!currentObject) return;

    if (currentObject.layer === ObjectLayer.Title) {
      setTitleId(currentObject.id);
    } else {
      setTitleId(currentObject.parentTitleId);
    }
  }, [currentObject]);

  return (
    <Modal
      title={t("modal:title.selectGroupParent")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      height={700} // Todo: Might need to delete later
      footer={
        <Button
          variant="contained"
          color="primary"
          onClick={handleMoveAsset}
          startIcon={!showLoader && <CreateNewFolderOutlinedIcon />}
          fullWidth
          disabled={selectedItems.length === 0 || showLoader}
        >
          {showLoader ? <CircularProgress size={20} thickness={5} color="secondary" /> : t("button:createGroupHere")}
        </Button>
      }
    >
      {titleId && (
        <MoveAssetTreeView
          treeRootId={titleId}
          selectableObjectLayers={selectableObjectLayers}
          objectsIdsToDisable={objectsIdsToDisable}
          objectIdsToHilight={[]}
        />
      )}
    </Modal>
  );
});

export default ModalSelectGroupParent;
